import styled from 'styled-components';
import { useFormikContext } from 'formik';
import { withStyles, FormControlLabel, Checkbox } from '@material-ui/core';
import { black } from '@avangard/ui/colors';

import { StudentOnlineApplicationBlock } from '@modules/students/moleculas';

import type { UpdateStudentOnlineApplicationFormValues } from '@modules/students/requests';

const StudentOnlineApplicationIntroductionStep = () => {
    const { values, handleChange } = useFormikContext<UpdateStudentOnlineApplicationFormValues>();

    return (
        <StudentOnlineApplicationBlock>
            <Title>Перечень абсолютных противопоказаний к прохождению учебных сборов</Title>

            <Content>
                <ol>
                    <li>Любые заболевания, в том числе хронические, в периоде обострения.</li>
                    <li>Любые инфекционные и паразитарные заболевания, в том числе туберкулез.</li>
                    <li>
                        Инфекционные заболевания кожи, возможные для передачи (микоз, чесотка и
                        пр.).
                    </li>
                    <li>Все формы педикулеза.</li>
                    <li>Все формы гельминтоза.</li>
                    <li>Злокачественные новообразования, в ремиссии менее 1 года.</li>
                    <li>
                        Бронхиальная астма в натуральной ремиссии (без приема медикаментов) менее 1
                        года.
                    </li>
                    <li>Все формы эпилепсии, включая судорожный синдром любой этиологии.</li>
                    <li>
                        Психические и поведенческие расстройства, в состоянии обострения или
                        неустойчивой натуральной ремиссии, сопровождающиеся нарушением настроения,
                        поведения и социальной адаптации, и представляющие опасность для себя и
                        окружающих.
                    </li>
                    <li>
                        Нарушения опорно–двигательного аппарата, последствия травм, отравлений и
                        других воздействий внешних причин, требующие индивидуальной помощи и ухода,
                        включая малоинвазивные процедуры, обработку хирургических швов, установку и
                        обслуживание катетеров и т.д.
                    </li>
                    <li>
                        Переломы, вывихи и растяжения, по которым сохраняются рекомендации в
                        значительном ограничении физической нагрузки, на момент заезда, либо если
                        критически ограничены нагрузки, на которых основана программа подготовки УМЦ
                        «Авангард».
                    </li>
                    <li>
                        Сахарный диабет, в форме требующей медикаментозного сопровождения, либо не
                        совместимый с общим режимом питания.
                    </li>
                    <li>Системные заболевания соединительной ткани.</li>
                    <li>Зависимость от алкоголя, наркотиков, психоактивных веществ.</li>
                    <li>
                        Сердечно-сосудистые заболевания и патологии связанные с необходимостью
                        ограничения физической нагрузки (3 группа здоровья, связанная с
                        кардиологией).
                    </li>
                    <li>ОРВИ перенесенные менее чем за 7 дней до даты заезда.</li>
                    <li>
                        Некомпенсированные (очками либо линзами) проблемы со зрением в диапазоне
                        отклонений 6 ед. либо с разницей отклонений от 6 ед. по правому и левому
                        глазу.
                    </li>
                    <li>
                        Травмы кожных покровов в стадии воспаления (в.т.ч. некротические поражения и
                        ожоги) требующие регулярной асептической обработки и соблюдения
                        асептического режима.
                    </li>
                    <li>Категория годности к воинской службе «Г», «Д».</li>
                </ol>

                <StyledFormControlLabel
                    label='Ознакомлен с перечнем абсолютных противопоказаний к прохождению учебных сборов'
                    control={
                        <Checkbox
                            id='introduction.passed'
                            name='introduction.passed'
                            checked={values.introduction.passed}
                            onChange={handleChange}
                        />
                    }
                />
            </Content>
        </StudentOnlineApplicationBlock>
    );
};

const StyledFormControlLabel = withStyles(() => ({
    root: {
        marginTop: 24,
    },
}))(FormControlLabel);

const Title = styled.div`
    color: ${black[80]};
    font-size: 2rem;
    font-weight: 600;
`;

const Content = styled.div`
    ol {
        margin-top: 24px;
        padding-left: 20px;
        list-style: auto;

        li {
            color: ${black[54]};
            font-size: 1.4rem;
            line-height: 22px;
        }
    }
`;

export { StudentOnlineApplicationIntroductionStep };
